import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BatchCollectionUpdateModel extends BaseModel {
  auction_collection_uuid = null;

  rules = {
    auction_collection_uuid: ''
  };

  attributeLabels = {
    auction_collection_uuid: i18n.t('Collection'),
  };

  attributeHints = {
    auction_collection_uuid: i18n.t('If left blank, collection will be removed for all selected items'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
